import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentDashboardAnalyticsService } from '@payments/pages/payment-dashboard/tracking/analytics/payment-dashboard-analytics.service';
import { PaymentDashboardRowsComponent } from '../payment-dashboard-rows.component';

@Component({
  selector: 'app-ar-aging-row-desktop',
  templateUrl: './ar-aging-row-desktop.component.html',
  styleUrls: [
    '../payment-dashboard-rows.component.scss',
    './ar-aging-row-desktop.component.scss',
  ],
})
export class ARAgingRowDesktopComponent extends PaymentDashboardRowsComponent {
  @Input() isShrink = true;
  @Output() emitClickTerm = new EventEmitter<boolean>();

  constructor(
    readonly router: Router,
    protected paymentDashboardAnalytics: PaymentDashboardAnalyticsService,
  ) {
    super(router, paymentDashboardAnalytics);
  }

  onClickTerm(shrink: boolean) {
    this.emitClickTerm.emit(shrink);
  }

  get truncatedTerm(): string {
    return !this.isShrink || this.customerMetrics.term.length <= 10
      ? this.customerMetrics.term
      : this.customerMetrics.term.slice(0, 10) + '...';
  }
}
